import React, { useState, useEffect, Fragment, memo } from 'react';
import { useFormikContext } from 'formik';
import styles from './BusinessDetails.module.css';
import CommonInput from '../../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonDatePicker from '../../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import {
  addBusinessDetail,
  getBusinessDetail
} from '../../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../../common/utils/applicantionInfo';
import PopUp from '../../../../../common/components/PopUp/PopUp';
import get from 'lodash/get';
import InputTypeNumber from '../../../../../common/components/InputTypeNumber/InputTypeNumber';
import * as _ from 'lodash';
import moment from 'moment';
import withErrorHandler from '../../../../..//hoc/withErrorHandler/withErrorHandler';

const BusinessDetails = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const { business_details_box, commonInputDIv } = styles;
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  useEffect(() => {
    setType('loading');
    setText('Getting Details Please Wait...');
    setShow(true);
    let applicant = getApplicantionInfo();
    getBusinessDetail(applicant.leadId, applicant.leadApplicantId)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        if (res) {
          setFieldValue('clinicfirm', res?.firmName || '');
          setFieldValue('workers', res?.workerCount || '');
          setFieldValue('year', {
            value: res?.registrationDate
              ? moment(res?.registrationDate).year()
              : moment().year(),
            label: res?.registrationDate
              ? moment(res?.registrationDate).year()
              : moment().year()
          });
          setFieldValue('month', {
            value: res?.registrationDate
              ? moment(res?.registrationDate).format('MMMM')
              : '',
            label: res?.registrationDate
              ? moment(res?.registrationDate).format('MMMM')
              : 'Month'
          });
          setFieldValue('registrationdate', {
            value: res?.registrationDate
              ? parseInt(moment(res?.registrationDate).date())
              : '',
            label: res?.registrationDate
              ? parseInt(moment(res?.registrationDate).date())
              : 'Date'
          });
          setFieldValue('commyear', {
            value: res?.commencementDate
              ? moment(res?.commencementDate).year()
              : moment().year(),
            label: res?.commencementDate
              ? moment(res?.commencementDate).year()
              : moment().year()
          });
          setFieldValue('commmonth', {
            value: res?.commencementDate
              ? moment(res?.commencementDate).format('MMMM')
              : '',
            label: res?.commencementDate
              ? moment(res?.commencementDate).format('MMMM')
              : 'Month'
          });
          setFieldValue('commencementdate', {
            value: res?.commencementDate
              ? parseInt(moment(res?.commencementDate).date())
              : '',
            label: res?.commencementDate
              ? parseInt(moment(res?.commencementDate).date())
              : 'Date'
          });
        } else {
          handleSubmit();
        }
        setShow(false);
      })
      .catch(error => {});
  }, []);

  const handleBusinessDetail = () => {
    setType('loading');
    setText('Adding details Please Wait..');
    setShow(true);
    let applicant = getApplicantionInfo();
    let body = {
      firmName: values?.clinicfirm || '',
      workerCount: values?.workers || '',
      registrationDate: new Date(
        `${values?.year?.value}-${values?.month?.value}-${values?.registrationdate?.value}`
      ),
      commencementDate: new Date(
        `${values?.commyear?.value}-${values?.commmonth?.value}-${values?.commencementdate?.value}`
      )
    };

    addBusinessDetail(applicant.leadId, applicant.leadApplicantId, body)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        } else {
          handleSubmit();
        }
        setShow(false);
      })
      .catch(error => {});
  };

  return (
    <Fragment>
      <div className={`${business_details_box}`}>
        <h1 className="text-left pt-4 pl-10 font-roboto text-md font-semibold">
          Business Details
        </h1>
        <div
          className={`m-2 md:mx-auto p-6 py-3 md:px-8 md:py-3
                 bg-white  rounded-lg font-normal font-roboto text-sm text-black-500 flex flex-wrap`}
        >
          <div className={`${commonInputDIv} w-full md:w-6/12 mt-4`}>
            <CommonInput
              name="clinicfirm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.clinicfirm}
              stylesContainer={{
                maxWidth: '100%'
              }}
              legendName="Clinic/Firm Name"
              error={touched.clinicfirm && errors.clinicfirm}
              errorMsg={errors.clinicfirm}
              touched={touched.clinicfirm}
            />
          </div>
          <div className={`${commonInputDIv} w-full md:w-6/12 mt-4`}>
            <InputTypeNumber
              name="workers"
              value={values.workers}
              maxLength={7}
              minLength={0}
              onChange={handleChange}
              onBlur={handleBlur}
              stylesContainer={{ maxWidth: '100%' }}
              legendName="Number of Worker"
              legendStyle={{ paddingLeft: '0px' }}
              inputStyle={{
                fontWeight: 'normal'
              }}
              error={touched.workers && errors.workers}
              errorMsg={errors.workers}
              touched={touched.workers}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              showInText={false}
              rupeeIcon={false}
            />
          </div>
          <div className={`${commonInputDIv}  w-full md:w-6/12 mt-4`}>
            <div className="text-black-600 font-roboto font-normal text-sm pb-2">
              Date of registration
            </div>
            <div className={`w-full`}>
              <CommonDatePicker
                onChangeMonth={(value, isValidDate) => {
                  setFieldValue('month', value, true);
                  setFieldTouched('month', true, false);
                  if (!isValidDate) {
                    setFieldValue(
                      'registrationdate',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeYear={(value, isValidDate) => {
                  setFieldValue('year', value, true);
                  setFieldTouched('year', true, false);

                  if (!isValidDate) {
                    setFieldValue(
                      'registrationdate',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeDate={value => {
                  setFieldValue('registrationdate', value, true);
                  setFieldTouched('registrationdate', true, false);
                }}
                valueMonth={values.month}
                valueYear={values.year}
                valueDate={values.registrationdate}
                errorYear={touched.year && get(errors, 'year.value', false)}
                touchedYear={touched.year}
                onBlurYear={() => {
                  setFieldTouched('year', true, true);
                }}
                errorMonth={touched.month && get(errors, 'month.value', false)}
                touchedMonth={touched.month}
                onBlurMonth={() => {
                  setFieldTouched('month', true, true);
                }}
                errorDate={
                  touched.registrationdate &&
                  get(errors, 'registrationdate.value', false)
                }
                touchedDate={touched.registrationdate}
                onBlurDate={() => {
                  setFieldTouched('registrationdate', true, true);
                }}
                disableFuture={true}
                minYear={1947}
              />
            </div>
          </div>
          <div className={`${commonInputDIv} w-full md:w-6/12 mt-4`}>
            <div className="text-black-600 font-roboto font-normal text-sm pb-2">
              Date of commencement
            </div>
            <div className={` w-full`}>
              <CommonDatePicker
                onChangeMonth={(value, isValidDate) => {
                  setFieldValue('commmonth', value, true);
                  setFieldTouched('commmonth', true, false);
                  if (!isValidDate) {
                    setFieldValue(
                      'commencementdate',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeYear={(value, isValidDate) => {
                  setFieldValue('commyear', value, true);
                  setFieldTouched('commyear', true, false);

                  if (!isValidDate) {
                    setFieldValue(
                      'commencementdate',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeDate={value => {
                  let date = `${values.commyear}-${values.commmonth}-${value}`;
                  setFieldValue('commencementdate', value, true);
                  setFieldTouched('commencementdate', true, false);
                }}
                valueMonth={values.commmonth}
                valueYear={values.commyear}
                valueDate={values.commencementdate}
                errorYear={
                  touched.commyear && get(errors, 'commmyear.value', false)
                }
                touchedYear={touched.commyear}
                onBlurYear={() => {
                  setFieldTouched('commyear', true, true);
                }}
                errorMonth={
                  touched.commmonth && get(errors, 'commmonth.value', false)
                }
                touchedMonth={touched.commmonth}
                onBlurMonth={() => {
                  setFieldTouched('commmonth', true, true);
                }}
                errorDate={
                  touched.commencementdate &&
                  get(errors, 'commencementdate.value', false)
                }
                touchedDate={touched.commencementdate}
                onBlurDate={() => {
                  setFieldTouched('commencementdate', true, true);
                }}
                disableFuture={true}
                minYear={1947}
              />
            </div>
          </div>
        </div>
        <button
          disabled={Object.keys(errors).length != 0 ? true : false}
          className="submitButton w-48"
          type="button"
          onClick={handleBusinessDetail}
        >
          Next
        </button>
        <PopUp type={type} text={text} setShow={setShow} show={show} />
      </div>
    </Fragment>
  );
};
export default memo(withErrorHandler(BusinessDetails));
